<div>

  <p-table class="custom-snmp-history-table history-table" [value]="entries" [scrollable]="true" scrollHeight="calc(560px)"
    [resizableColumns]="true">
    <ng-template pTemplate="header">
      <tr>
        <th pResizableColumn>Device Name</th>
        <th pResizableColumn>Name</th>
        <th pResizableColumn>Timestamp</th>
        <th pResizableColumn>Value</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
      <tr>
        @if (rowGroupMetadata[rowData.groupKey].index === rowIndex) {
          <td
            [attr.rowspan]="rowGroupMetadata[rowData.groupKey].size"
            class="history-entry">
            <div class="uv-table-value">{{rowData.deviceName}}</div>
          </td>
        }
        @if (rowGroupMetadata[rowData.groupKey].index === rowIndex) {
          <td
            [attr.rowspan]="rowGroupMetadata[rowData.groupKey].size"
            class="history-entry">
            <div class="uv-table-value">{{rowData.entryName}}</div>
          </td>
        }
        <td pTooltip="{{formatDateHm(rowData.timestamp)}}">
          <div class="uv-table-value">{{formatDateHm(rowData.timestamp)}}</div>
        </td>
        <td pTooltip="{{rowData.value}}">
          <div class="uv-table-value">{{rowData.value}}</div>
        </td>
      </tr>
    </ng-template>
  </p-table>

</div>
